import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-carousel-item-placeholder.scss';

import type { TileStandardCarouselType } from 'types';

applyTranslations(require('../../tile-standard-carousel.i18n.json'));

type Props = {
  type: TileStandardCarouselType
};

const MSG_KEY = 'tile_standard_carousel';

const TileStandardCarouselItemPlaceholder = (
  {
    type
  }: Props
): JSX.Element => {
  const msg = __t(`${MSG_KEY}.messages.no_content_past_year`);

  const containerClasses = classnames('tile-standard-carousel-item-placeholder', {
    [`tile-standard-carousel-item-placeholder--type-${type}`]: Boolean(type)
  });

  return (
    <div
      className={containerClasses}
      title={msg}
    >
      <SVGDynamicIcon
        name="puzzle-piece-custom-fg"
        width={22}
        height={22}
        customColor="grey-light"
      />
      <div>
        {msg}
      </div>
    </div>
  );
};

export default TileStandardCarouselItemPlaceholder;
